<template>
    <div>
        <div class="flex flex-col items-center justify-center lg:mx-12 md:flex-row md:items-stretch md:mx-0 py-2 xl:mx-40">
            <div v-for="(application, index) in applications" class="flex-1 lg:mx-6 max-w-225px md:mx-3 md:my-0 md:w-1/3 my-4 w-full">
                <application-card :key="index" :application="application" :is-editable="false">
                    <svg v-if="application.slug === 'crm'" class="fill-current relative w-20" :class="[ application.status === 'active' ? 'text-purple-100' : 'text-gray-100' ]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M8 24l3-9h-9l14-15-3 9h9l-14 15z"></path>
                    </svg>
                    <svg v-else-if="application.slug === 'tasks'" class="fill-current relative w-20" :class="[ application.status === 'active' ? 'text-red-100' : 'text-gray-100' ]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M4.967 15c-2.743 0-4.967-2.238-4.967-5 0-2.761 2.224-5 4.967-5h5.033v10h-5.033zm7.04 7.475c-.52-.424-.902-.994-1.095-1.637l-1.151-3.827h-5.125l1.905 5.883c.214.659.828 1.106 1.521 1.106h3.439c.358 0 .677-.225.797-.562.12-.337.015-.713-.263-.939l-.028-.024zm-.007-17.475v10c3.164.509 7.161 1.992 12 5v-20c-4.964 3.085-8.876 4.502-12 5z"></path>
                    </svg>
                    <svg v-else-if="application.slug === 'budgets'" class="fill-current relative w-20" :class="[ application.status === 'active' ? 'text-blue-100' : 'text-gray-100' ]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M5 19h-4v-4h4v4zm6 0h-4v-8h4v8zm6 0h-4v-13h4v13zm6 0h-4v-19h4v19zm1 2h-24v2h24v-2z"></path>
                    </svg>
                </application-card>
            </div>
        </div>
    </div>
</template>

<script>
import ApplicationCard from './partials/application-card.vue';

export default {
    components: {
        'application-card': ApplicationCard,
    },

    props: {
        applications: {
            type: Array,
            required: true,
        },
    },
};
</script>
